import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { LayoutService } from "../../services/layout.service";
import icBookmarks from "@iconify/icons-ic/twotone-bookmarks";
import emojioneUS from "@iconify/icons-emojione/flag-for-flag-united-states";
import emojioneDE from "@iconify/icons-emojione/flag-for-flag-germany";
import icMenu from "@iconify/icons-ic/twotone-menu";
import { ConfigService } from "../../services/config.service";
import { ConfigService as AppConfigService } from "src/app/services/config.service";
import {
  debounceTime,
  filter,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import icPersonAdd from "@iconify/icons-ic/twotone-person-add";
import icAssignmentTurnedIn from "@iconify/icons-ic/twotone-assignment-turned-in";
import icBallot from "@iconify/icons-ic/twotone-ballot";
import icDescription from "@iconify/icons-ic/twotone-description";
import icAssignment from "@iconify/icons-ic/twotone-assignment";
import icReceipt from "@iconify/icons-ic/twotone-receipt";
import icDoneAll from "@iconify/icons-ic/twotone-done-all";
import { NavigationService } from "../../services/navigation.service";
import icArrowDropDown from "@iconify/icons-ic/twotone-arrow-drop-down";
// import { MegaMenuComponent } from "../../components/mega-menu_e/mega-menu.component";
import icSearch from "@iconify/icons-ic/twotone-search";
import icStethoscope from "@iconify/icons-fa-solid/stethoscope";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { GoogleAuthService } from "./google.service";
import { Router } from "@angular/router";
import { AuthService } from "src/app/pages/auth/authServices";
import { forkJoin, Subject, Subscription } from "rxjs";
import { ReportsService } from "src/app/pages/reports/reports.service";
import { AttorneyAndInsuranceService } from "src/app/pages/user-management/attornetAndInsurance";
@Component({
  selector: "vex-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
  animations: [
    trigger("expandCollapse", [
      state(
        "collapsed",
        style({
          width: "0",
          opacity: "0",
          overflow: "hidden",
        })
      ),
      state(
        "expanded",
        style({
          width: "*",
          opacity: "1",
        })
      ),
      transition("collapsed <=> expanded", [animate("300ms ease-in-out")]),
    ]),
  ],
})
export class ToolbarComponent implements OnInit, OnDestroy {
  @Input() mobileQuery: boolean;

  get notificationsDisabled(): boolean {
    return this.appConfigService.areNotificationsDisabled();
  }

  @Input()
  @HostBinding("class.shadow-b")
  hasShadow: boolean;

  /** Wraps search input + dropdown; clicks outside clear the query. */
  @ViewChild("searchBoxHost", { static: false })
  private searchBoxHost?: ElementRef<HTMLElement>;

  @ViewChild("searchInputRef", { static: false })
  private searchInputRef?: ElementRef<HTMLInputElement>;

  navigationItems = this.navigationService.items;

  isHorizontalLayout$ = this.configService.config$.pipe(
    map((config) => config.layout === "horizontal")
  );
  isVerticalLayout$ = this.configService.config$.pipe(
    map((config) => config.layout === "vertical")
  );
  isNavbarInToolbar$ = this.configService.config$.pipe(
    map((config) => config.navbar.position === "in-toolbar")
  );
  isNavbarBelowToolbar$ = this.configService.config$.pipe(
    map((config) => config.navbar.position === "below-toolbar")
  );
  componentName = "Encounter Tabs";
  permissinArray = [];
  icSearch = icSearch;
  icBookmarks = icBookmarks;
  emojioneUS = emojioneUS;
  emojioneDE = emojioneDE;
  icMenu = icMenu;
  icPersonAdd = icPersonAdd;
  icAssignmentTurnedIn = icAssignmentTurnedIn;
  icBallot = icBallot;
  icDescription = icDescription;
  icAssignment = icAssignment;
  icReceipt = icReceipt;
  icDoneAll = icDoneAll;
  icArrowDropDown = icArrowDropDown;
  icStethoscope = icStethoscope;
  showResults: boolean = false;
  isLoading: boolean = false;
  searchQuery: string = "";

  // Main Pages
  mainRoutes = [
    { label: "Home", route: "/dashboard", imgIcon: "cottage" },
    { label: "Calendar", route: "/calendar", imgIcon: "calendar_month" },
    { label: "Queue", route: "/queue", imgIcon: "list_alt" },
    { label: "Task List", route: "/reports", imgIcon: "task" },
    { label: "Reporting", route: "/reporting", imgIcon: "insert_chart" },
    { label: "Billing", route: "/billing", imgIcon: "paid" },
    { label: "Report Print Queue", route: "/print-queue", imgIcon: "print" },
    { label: "Database", route: "/database/user&roles", imgIcon: "settings" },
  ];

  databaseRoutes = [
    {
      label: "Roles & Users",
      route: "/database/user&roles",
      imgIcon: "settings",
    },
    {
      label: "Clinic Locations",
      route: "/database/clinic_locations",
      imgIcon: "location_on",
    },
    { label: "Applicants", route: "/database/applicant", imgIcon: "person" },
    { label: "Attorneys", route: "/database/attorney", imgIcon: "gavel" },
    {
      label: "Insurance",
      route: "/database/insurance_company",
      imgIcon: "policy",
    },
    {
      label: "Interpreters",
      route: "/database/interpreter",
      imgIcon: "translate",
    },
    { label: "Body parts", route: "/database/body_parts", imgIcon: "healing" },
    {
      label: "Business setup",
      route: "/database/business_setup",
      imgIcon: "business",
    },
    { label: "Due dates", route: "/database/dueDate", imgIcon: "event" },
    ...(!this.appConfigService.areNotificationsDisabled()
      ? [
          {
            label: "Notification settings",
            route: "/database/notification_setting",
            imgIcon: "notifications",
          },
        ]
      : []),
    {
      label: "ML code & Modifiers",
      route: "/database/ml_modifiers",
      imgIcon: "code",
    },
  ];
  applicants: any;
  filteredApplicants: any[];

  clearSearch() {
    this.closeToolbarSearch();
  }

  /** Clears text, results, and dropdown (used by outside-click and clear button). */
  closeToolbarSearch(): void {
    this.showResults = false;
    this.searchQuery = "";
    this.onSearchInput("");
    const el = this.searchInputRef?.nativeElement;
    if (el) {
      el.value = "";
    }
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.searchQuery?.trim()) {
      return;
    }
    const host = this.searchBoxHost?.nativeElement;
    const target = event.target as Node | null;
    if (!host || !target || host.contains(target)) {
      return;
    }
    this.closeToolbarSearch();
  }

  filteredMainRoutes = [...this.mainRoutes];
  filteredDatabaseRoutes = [...this.databaseRoutes];
  userIsAuthenticated = false;
  userId: string;
  private authStatusSub: Subscription;
  private roleChangedSub: Subscription;
  filteredEncounters: any[] = [];
  errorMessage: string;
  encounters: any;
  private toolbarSearch$ = new Subject<string>();
  private toolbarSearchSub?: Subscription;

  constructor(
    private layoutService: LayoutService,
    private configService: ConfigService,
    private appConfigService: AppConfigService,
    private navigationService: NavigationService,
    private googleAuthService: GoogleAuthService,
    private router: Router,
    public service: ReportsService,
    private authService: AuthService,
    public service_2: AttorneyAndInsuranceService
  ) {}

  ngOnInit() {
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.permissinArray = JSON.parse(localStorage.getItem("permission"));
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((isAuthenticated) => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    // Refresh permission array whenever the active role changes so that
    // toolbar link visibility updates without a full page reload.
    this.roleChangedSub = this.authService.roleChanged$.subscribe(() => {
      this.permissinArray = JSON.parse(localStorage.getItem("permission")) || [];
    });
    // this.searchSubject
    //   .pipe(debounceTime(400), distinctUntilChanged())
    //   .subscribe((searchTerm: string) => {
    //     this.filterByCase(searchTerm);
    //   });
    this.toolbarSearchSub = this.toolbarSearch$
      .pipe(
        debounceTime(400),
        filter((t) => t.trim().length > 0),
        tap(() => {
          this.isLoading = true;
        }),
        switchMap((term) => {
          const trimmed = term.trim();
          const lower = trimmed.toLowerCase();
          const applicants$ = this.service_2.searchApplicantsForToolbar(
            trimmed,
            25
          );
          if (!/^case\s+\S+/i.test(trimmed)) {
            return applicants$.pipe(
              map((res) => ({
                applicantRows: res.data,
                caseRows: [] as any[],
              }))
            );
          }
          return forkJoin({
            applicantsRes: applicants$,
            encRes: this.service.searchEncounterByCaseNumber(lower),
          }).pipe(
            map(({ applicantsRes, encRes }) => ({
              applicantRows: applicantsRes.data,
              caseRows: (encRes as { data?: any[] })?.data || [],
            }))
          );
        })
      )
      .subscribe({
        next: ({ applicantRows, caseRows }) => {
          this.applicants = applicantRows;
          this.filteredApplicants = applicantRows;
          this.caseMatches = caseRows;
          this.filteredEncounters = [];
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  // getAllEncounters() {
  //   this.isLoading = true;
  //   this.service.getAllCase({}).subscribe({
  //     next: (data:any) => {
  //       this.encounters = data.data;
  //       this.isLoading = false;
  //       // console.log("Encounters data:", this.encounters);
  //     },
  //     error: (err) => {
  //       this.handleError(err);
  //       this.isLoading = false;
  //     },
  //     complete: () => {
  //       console.log('Fetching encounters completed.');
  //     }
  //   });
  // }
get showNoResults(): boolean {
  if (this.isLoading || !this.searchQuery?.trim()) {
    return false;
  }
  return (
    Array.isArray(this.caseMatches) &&
    Array.isArray(this.filteredApplicants) &&
    this.caseMatches.length === 0 &&
    this.filteredApplicants.length === 0
  );
}
  handleError(err: any) {
    if (err.status === 401) {
      this.errorMessage = "You do not have permission to access this route.";
    } else {
      this.errorMessage =
        "An unexpected error occurred. Please try again later.";
    }
    this.isLoading = false;
  }
  caseMatches: any[] = [];
  nameMatches: any[] = [];

  /** Re-run search after paste when the browser skips `input` for unchanged values. */
  onSearchPaste(): void {
    setTimeout(() => {
      const value = this.searchInputRef?.nativeElement?.value ?? "";
      this.onSearchInput(value);
    }, 0);
  }

  /** Instant route filter + debounced remote applicant/case search (see ngOnInit). */
  onSearchInput(searchTerm: string) {
    this.searchQuery = searchTerm;
    if (!searchTerm.trim()) {
      this.isLoading = false;
      this.filteredMainRoutes = [...this.mainRoutes];
      this.filteredDatabaseRoutes = [...this.databaseRoutes];
      this.caseMatches = [];
      this.filteredApplicants = [];
      this.filteredEncounters = [];
      return;
    }

    this.isLoading = true;
    this.caseMatches = [];
    this.filteredApplicants = [];

    const lowerSearchTerm = searchTerm.toLowerCase();

    this.filteredMainRoutes = this.mainRoutes.filter((route) =>
      route.label.toLowerCase().includes(lowerSearchTerm)
    );
    this.filteredDatabaseRoutes = this.databaseRoutes.filter((route) =>
      route.label.toLowerCase().includes(lowerSearchTerm)
    );

    this.toolbarSearch$.next(searchTerm);
  }


  navigateTo(route: string) {
    this.showResults = false;
    this.router.navigateByUrl(route);
  }

  /** Stable encounter id for routerLink queryParams (lean API returns nested _id). */
  caseEncounterQueryId(encounter: any): string {
    const ref = encounter?.encounterId;
    if (!ref) return "";
    const raw = ref._id != null ? ref._id : ref;
    return raw != null ? String(raw) : "";
  }

  /** Mirrors template *ngIf branches — true when no branch rendered but encounter link exists. */
  toolbarCaseSearchNeedsFallback(encounter: any): boolean {
    if (!this.caseEncounterQueryId(encounter)) return false;
    const e = encounter;
    const branch1 =
      e &&
      e.history_status !== null &&
      e.status !== null;
    const branch2 =
      e &&
      e.history_status == null &&
      e.status == null &&
      e.deposition_status == null;
    const branch3 = e && e.deposition_status !== null;
    return !!e && !branch1 && !branch2 && !branch3;
  }

  hideResults() {
    setTimeout(() => {
      this.showResults = false;
    }, 200);
  }

  handleGoogleDriveAuth() {
    const authUrl = this.googleAuthService.getAuthorizationUrl();
    window.location.href = authUrl;
  }
  openQuickpanel() {
    this.layoutService.openQuickpanel();
  }
  ngOnDestroy() {
    this.toolbarSearchSub?.unsubscribe();
    this.authStatusSub.unsubscribe();
    this.roleChangedSub?.unsubscribe();
    this.filteredDatabaseRoutes = [];
    this.filteredMainRoutes = [];
    this.caseMatches = [];
    this.filteredEncounters = [];
    this.applicants = [];
  }
  openSidenav() {
    this.layoutService.openSidenav();
  }

  redirectTo(url: string): void {
    window.open(url, "_blank");
  }

  openSearch() {
    this.layoutService.openSearch();
  }

  isExpanded = false;

  toggleSearch() {
    this.isExpanded = !this.isExpanded;
  }

  checkPermissionForSubComponent(subComponentName: string): boolean {
    const component = this.permissinArray.find(
      (c) => c.component === this.componentName
    );

    if (!component) return false;

    const subComponent = component.subComponent.find(
      (s) => s.subComponentName === subComponentName
    );

    if (!subComponent) return false;

    const permission = subComponent.permissions.find((p) => p.isPermission);

    return !!permission;
  }

  getFirstAvailableSubComponent(): { name: string; route: string } | null {
    const subComponents = [
      { name: "History", route: "/reports/oqme" },
      { name: "Record Review", route: "/reports/oqme/record" },
      { name: "Evaluation", route: "/reports/oqme/evaluation" },
      { name: "Editing", route: "/reports/oqme/editor" },
      { name: "Finalize Report", route: "/reports/oqme/finalize_report" },
      { name: "Submit Report", route: "/reports/oqme/submit_report" },
      { name: "Transcription", route: "/reports/oqme/transcription" },
      { name: "Deposition", route: "/reports/oqme/deposition" },
    ];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }

  getFirstAvailablePQMESSubComponent(): { name: string; route: string } | null {
    const subComponents = [
      { name: "Record Review", route: "/reports/oqme/record" },
      { name: "Editing", route: "/reports/oqme/editor" },
      { name: "Finalize Report", route: "/reports/oqme/finalize_report" },
      { name: "Submit Report", route: "/reports/oqme/submit_report" },
      { name: "Transcription", route: "/reports/oqme/transcription" },
      { name: "Deposition", route: "/reports/oqme/deposition" },
    ];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }

  getDepositionAvailableSubComponent(): { name: string; route: string } | null {
    const subComponents = [
      { name: "Deposition", route: "/reports/oqme/deposition" },
    ];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }
}
